import { render, staticRenderFns } from "./imageText.module.vue?vue&type=template&id=61b9e5e4&scoped=true"
import script from "./imageText.module.vue?vue&type=script&lang=js"
export * from "./imageText.module.vue?vue&type=script&lang=js"
import style0 from "./imageText.module.vue?vue&type=style&index=0&id=61b9e5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b9e5e4",
  null
  
)

export default component.exports